import React from 'react';
import PropTypes from 'prop-types';

import { sendReactError } from 'services/app-service';
import { userAgent } from 'components/utils/device';

class ComponentErrorBoundary extends React.Component {

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  async componentDidCatch(error, info) {
    this.setState({ hasError: true });
    const module = await import(/* webpackChunkName: "stacktrace-js" */ 'stacktrace-js');
    const StackTrace = module.default;
    const stackFrames = await StackTrace.fromError(error);
    await sendReactError({
      type: 'React boundary',
      error: error.message,
      version: global.version,
      parsedStack: stackFrames ? stackFrames.map(sf => sf.toString()).join('\n') : '',
      componentStack: info ? info.componentStack : '',
      url: window ? window.location.href : '',
      agent: userAgent,
      date: new Date(),
      dimensions: {
        width: window ? window.innerWidth : '',
        height: window ? window.innerHeight : ''
      }
    });
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

ComponentErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};

export default ComponentErrorBoundary;
